import { render, staticRenderFns } from "./StoreNav.vue?vue&type=template&id=04b9e3d0&scoped=true&"
import script from "./StoreNav.vue?vue&type=script&lang=js&"
export * from "./StoreNav.vue?vue&type=script&lang=js&"
import style0 from "./StoreNav.vue?vue&type=style&index=0&id=04b9e3d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9e3d0",
  null
  
)

export default component.exports